// ----------------------------------------------------------------------
// <copyright file="Izenda.AuthorizationConstants.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

export default {
  PERMISSION_KEY: {
    FullReportAndDashboardAccess: 'fullReportAndDashboardAccess',
    SystemConfigurationScheduledInstancesValue: 'systemConfiguration.scheduledInstances.value',
    TenantSetupActionsCreate: 'tenantSetup.actions.create',
    TenantSetupActionsEdit: 'tenantSetup.actions.edit',
    TenantSetupActionsDel: 'tenantSetup.actions.del',
    TenantSetupPermissionsValue: 'tenantSetup.permissions.value',
    DataSetupDataModelValue: 'dataSetup.dataModel.value',
    DataSetupDataConnectorsValue: 'dataSetup.dataConnectors.value',
    DataSetupDataModelCustomViewCreate: 'dataSetup.dataModel.customView.create',
    DataSetupDataModelCustomViewEdit: 'dataSetup.dataModel.customView.edit',
    DataSetupDataModelCustomViewDelete: 'dataSetup.dataModel.customView.delete',
    DataSetupAdvancedSettingsCategory: 'dataSetup.advancedSettings.category',
    DataSetupAdvancedSettingsOthers: 'dataSetup.advancedSettings.others',
    DataSetupImportValue: 'dataSetup.import.value',
    UserSetupUserRoleAssociationValue: 'userSetup.userRoleAssociation.value',
    UserSetupActionsCreate: 'userSetup.actions.create',
    UserSetupActionsEdit: 'userSetup.actions.edit',
    UserSetupActionsDel: 'userSetup.actions.del',
    UserSetupActionsConfigureSecurityOptions: 'userSetup.actions.configureSecurityOptions',
    RoleSetupActionsCreate: 'roleSetup.actions.create',
    RoleSetupActionsEdit: 'roleSetup.actions.edit',
    RoleSetupActionsDel: 'roleSetup.actions.del',
    RoleSetupDataModelAccessValue: 'roleSetup.dataModelAccess.value',
    RoleSetupPermissionsValue: 'roleSetup.permissions.value',
    RoleSetupGrantRoleWithFullReportAndDashboardAccessValue:
      'roleSetup.grantRoleWithFullReportAndDashboardAccess.value',
    ReportsCanCreateNewReportValue: 'reports.canCreateNewReport.value',
    ReportsShowExploreMenuValue:'reports.showExploreMenu.value',
    ReportsDataSourcesSimpleDataSources: 'reports.dataSources.simpleDataSources',
    ReportsDataSourcesAdvancedDataSources: 'reports.dataSources.advancedDataSources',
    ReportsReportPartTypesChart: 'reports.reportPartTypes.chart',
    ReportsReportPartTypesForm: 'reports.reportPartTypes.form',
    ReportsReportPartTypesGauge: 'reports.reportPartTypes.gauge',
    ReportsReportPartTypesKPI: 'reports.reportPartTypes.kpi',
    ReportsReportPartTypesMap: 'reports.reportPartTypes.map',
    ReportsReportPartTypesEnableGoogleAddress: 'reports.reportPartTypes.isEnableGoogleAddress',
    ReportsCanCreateNewCategoryValue: 'reports.reportCategoriesSubcategories.canCreateNewCategory.value',
    ReportsPreventReportSharingValue: 'reports.reportCategoriesSubcategories.preventReportSharing.value',
    ReportsFilterPropertiesFilterLogic: 'reports.filterProperties.filterLogic',
    ReportsFilterPropertiesCrossFiltering: 'reports.filterProperties.crossFiltering',
    ReportsFieldPropertiesCustomURL: 'reports.fieldProperties.customURL',
    ReportsFieldPropertiesEmbeddedJavaScript: 'reports.fieldProperties.embeddedJavaScript',
    ReportsFieldPropertiesSubreport: 'reports.fieldProperties.subreport',
    ReportsActionsSchedule: 'reports.actions.schedule',
    ReportsActionsEmail: 'reports.actions.email',
    ReportsActionsViewReportHistory: 'reports.actions.viewReportHistory',
    ReportsActionsDel: 'reports.actions.del',
    ReportsActionsRegisterForAlerts: 'reports.actions.registerForAlerts',
    ReportsActionsPrint: 'reports.actions.print',
    ReportsActionsUnarchiveReportVersions: 'reports.actions.unarchiveReportVersions',
    ReportsActionsOverwriteExistingReport: 'reports.actions.overwriteExistingReport',
    ReportsActionsSubscribe: 'reports.actions.subscribe',
    ReportsActionsExporting: 'reports.actions.exporting',
    ReportsActionsConfigureAccessRights: 'reports.actions.configureAccessRights',
    DashboardsCanCreateNewDashboardValue: 'dashboards.canCreateNewDashboard.value',
    DashboardsCanCreateNewCategoryValue: 'dashboards.dashboardCategoriesSubcategories.canCreateNewCategory.value',
    DashboardsActionsSchedule: 'dashboards.actions.schedule',
    DashboardsActionsEmail: 'dashboards.actions.email',
    DashboardsActionsDel: 'dashboards.actions.del',
    DashboardsActionsSubscribe: 'dashboards.actions.subscribe',
    DashboardsActionsPrint: 'dashboards.actions.print',
    DashboardsActionsExporting: 'dashboards.actions.exporting',
    DashboardsActionsOverwriteExistingDashboard: 'dashboards.actions.overwriteExistingDashboard',
    DashboardsActionsConfigureAccessRights: 'dashboards.actions.configureAccessRights',
    SchedulingSchedulingScopeSystemUsers: 'scheduling.schedulingScope.systemUsers',
    SchedulingSchedulingScopeExternalUsers: 'scheduling.schedulingScope.externalUsers',
    EmailingDeliveryMethodLink: 'emailing.deliveryMethod.link',
    EmailingDeliveryMethodEmbeddedHTML: 'emailing.deliveryMethod.embeddedHTML',
    EmailingDeliveryMethodAttachment: 'emailing.deliveryMethod.attachment',
    EmailingAttachmentTypeWord: 'emailing.attachmentType.word',
    EmailingAttachmentTypeExcel: 'emailing.attachmentType.excel',
    EmailingAttachmentTypePdf: 'emailing.attachmentType.pdf',
    EmailingAttachmentTypeCsv: 'emailing.attachmentType.csv',
    EmailingAttachmentTypeXml: 'emailing.attachmentType.xml',
    EmailingAttachmentTypeJson: 'emailing.attachmentType.json',
    EmailingAttachmentTypeDefinition: 'emailing.attachmentType.definition',
    ExportingExportingFormatWord: 'exporting.exportingFormat.word',
    ExportingExportingFormatExcel: 'exporting.exportingFormat.excel',
    ExportingExportingFormatPdf: 'exporting.exportingFormat.pdf',
    ExportingExportingFormatCsv: 'exporting.exportingFormat.csv',
    ExportingExportingFormatXml: 'exporting.exportingFormat.xml',
    ExportingExportingFormatJson: 'exporting.exportingFormat.json',
    ExportingExportingFormatDefinition: 'exporting.exportingFormat.definition',
    ExportingExportingFormatQueryExecution: 'exporting.exportingFormat.queryExecution',
    ExportingExportingFormatIframe: 'exporting.exportingFormat.iframe',
    SystemwideCanSeeSystemMessagesValue: 'systemwide.canSeeSystemMessages.value'
  },
  PERMISSION_OPERATOR: {
    And: '&&',
    Or: '||'
  },
  ACCESS_RIGHT: {
    // Highest is 1
    FullAccess: 1,
    SaveAs: 2,
    QuickEdit: 3,
    Locked: 4,
    ViewOnly: 5,
    NoAccess: 6
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.AuthorizationConstants.js